export class Wallet {
  constructor(
    public readonly id: string,
    public readonly name: string,
    public readonly currency: string,
    public readonly availableBalance: number,
    public readonly spentBalance: number
  ) {
  }
}
